import { render, staticRenderFns } from "./FeedStudents.vue?vue&type=template&id=079cc516"
import script from "./FeedStudents.vue?vue&type=script&lang=js"
export * from "./FeedStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports